var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgContracts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7259 6.01186L12.5592 1.8452C12.4402 1.72615 12.3211 1.66663 12.1425 1.66663H4.52348C3.86872 1.66663 3.33301 2.20234 3.33301 2.8571V17.1428C3.33301 17.7976 3.86872 18.3333 4.52348 18.3333H15.714C16.3687 18.3333 16.9044 17.7976 16.9044 17.1428V6.42853C16.9044 6.24996 16.8449 6.13091 16.7259 6.01186ZM12.1425 3.0952L15.4759 6.42853H12.1425V3.0952ZM15.714 17.1428H4.52348V2.8571H10.9521V6.42853C10.9521 7.08329 11.4878 7.61901 12.1425 7.61901H15.714V17.1428Z",
    fill: "#E9EEF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5234 13.5714H5.71387V14.7619H14.5234V13.5714Z",
    fill: "#E9EEF7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5234 10H5.71387V11.1905H14.5234V10Z",
    fill: "#E9EEF7"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContracts);
export default __webpack_public_path__ + "static/media/Contracts.26c6263e7ffc1ba1e2580a54b9c71340.svg";
export { ForwardRef as ReactComponent };